{
  "version": "v5.0.0",
  "schemaVersion": "v5.0.0",
  "clientId": "orange-theory",
  "siteId": "5736520",
  "brandingConfig": {
    "primaryColor": "#FF6900",
    "secondaryColor": "#000000",
    "logo": "https://assets.orangetheory.com/logo.png",
    "theme": "energetic"
  },
  "views": {
    "detail": {
      "layout": "tabs",
      "breadcrumbs": true,
      "tabs": [
        {
          "key": "overview",
          "label": "Overview",
          "icon": "dashboard",
          "sections": [
            {
              "title": "Executive Summary",
              "collapsible": false,
              "component": "TextPanel",
              "fields": [{ "path": "executive_summary", "label": "", "type": "text" }]
            },
            {
              "title": "Key Information",
              "collapsible": false,
              "grid": 3,
              "fields": [
                {
                  "path": "primary_category",
                  "label": "Category",
                  "type": "badge",
                  "formatter": "humanize",
                  "span": 1
                },
                {
                  "path": "primary_subcategory",
                  "label": "Subcategory",
                  "type": "badge",
                  "formatter": "humanize",
                  "span": 1
                },
                {
                  "path": "analysis.secondary_topics",
                  "label": "Other Category",
                  "type": "badge",
                  "span": 1
                },
                {
                  "path": "revenue_priority",
                  "label": "Revenue Priority",
                  "type": "badge",
                  "span": 1,
                  "hover": "analysis.revenue_priority_evidence"
                },
                {
                  "path": "analysis.primary_topic.outcome.result",
                  "label": "Outcome",
                  "type": "badge",
                  "span": 1,
                  "hover": "analysis.primary_topic.outcome.reasoning"
                },
                {
                  "path": "credit_card_captured",
                  "label": "Credit Card",
                  "type": "badge",
                  "span": 1
                }
              ]
            },
            {
              "title": "Call Details",
              "collapsible": false,
              "grid": 3,
              "fields": [
                {
                  "path": "staff_name",
                  "label": "Staff Member",
                  "type": "badge",
                  "span": 1
                },
                {
                  "path": "fromPhoneNumber",
                  "label": "Customer Phone",
                  "type": "badge",
                  "span": 1
                },
                {
                  "path": "callStartTime",
                  "label": "Date/Time",
                  "type": "badge",
                  "formatter": "datetime",
                  "span": 1
                },
                {
                  "path": "callDuration",
                  "label": "Duration",
                  "type": "duration",
                  "format": "mm:ss",
                  "span": 1
                },
                {
                  "path": "call_state",
                  "label": "Call State",
                  "type": "badge",
                  "span": 1
                },
                {
                  "path": "analysis.customer_profile.type",
                  "label": "Customer Type",
                  "type": "badge",
                  "span": 1,
                  "hover": "analysis.customer_profile.evidence"
                }
              ]
            },
            {
              "title": "Secondary Topics",
              "collapsible": false,
              "condition": "secondary_topics.length > 0",
              "fields": [
                {
                  "path": "secondary_topics",
                  "label": "Additional Topics Discussed",
                  "type": "tags"
                }
              ]
            }
          ]
        },
        {
          "key": "follow-up",
          "label": "Follow-up",
          "icon": "psychology",
          "sections": [
            {
              "title": "",
              "collapsible": false,
              "variant": "primary",
              "grid": 2,
              "fields": [
                {
                  "path": "follow_up_needed",
                  "label": "Follow-up Required",
                  "type": "badge",
                  "span": 1
                },
                {
                  "path": "follow_up_reasons",
                  "label": "Follow-up Reasons",
                  "type": "list",
                  "span": 1,
                  "condition": "follow_up_needed === 'yes'"
                }
              ]
            }
          ]
        },
        {
          "key": "coaching1",
          "label": "Coaching Feedback",
          "icon": "psychology",
          "sections": [
            {
              "title": "Coaching Scenario",
              "collapsible": false,
              "variant": "primary",
              "fields": [
                {
                  "path": "analysis.practical_coaching.scenario_identified",
                  "label": "Scenario Identified",
                  "type": "header"
                }
              ]
            },
            {
              "title": "Detailed Feedback",
              "collapsible": false,
              "fields": [
                {
                  "path": "analysis.practical_coaching.detailed_feedback_items.what_was_said",
                  "label": "What Was Said",
                  "type": "quote"
                },
                {
                  "path": "analysis.practical_coaching.detailed_feedback_items.context",
                  "label": "Context",
                  "type": "text"
                },
                {
                  "path": "analysis.practical_coaching.detailed_feedback_items.what_could_have_been_said",
                  "label": "Recommended Response",
                  "type": "quote",
                  "highlight": true
                },
                {
                  "path": "analysis.practical_coaching.detailed_feedback_items.why_recommendation_is_better",
                  "label": "Why This Is Better",
                  "type": "text",
                  "icon": "lightbulb"
                }
              ]
            }
          ]
        }
      ]
    },
    "dashboard": {
      "title": "Orange Theory Call Analytics - v5 Simplified",
      "refreshInterval": 300,
      "layout": "grid",
      "widgets": [
        {
          "key": "todayStats",
          "title": "Today's Performance",
          "type": "statsGrid",
          "span": 12,
          "height": 120,
          "refresh": true,
          "metrics": [
            {
              "key": "totalCalls",
              "label": "Total Calls",
              "icon": "phone",
              "format": "number"
            },
            {
              "key": "humanConversations",
              "label": "Conversations",
              "icon": "chat",
              "format": "number"
            },
            {
              "key": "highRevenuePriority",
              "label": "High Revenue",
              "icon": "attach_money",
              "format": "number",
              "color": "green"
            },
            {
              "key": "followUpNeeded",
              "label": "Follow-ups",
              "icon": "assignment_turned_in",
              "format": "number",
              "color": "orange"
            },
            {
              "key": "creditCardsCaptured",
              "label": "Cards Captured",
              "icon": "credit_card",
              "format": "number",
              "color": "green"
            }
          ]
        },
        {
          "key": "customerTypeBreakdown",
          "title": "Customer Types (Last 7 Days)",
          "type": "pieChart",
          "span": 6,
          "height": 300,
          "dataPath": "customerTypeStats",
          "colorScheme": "customer"
        },
        {
          "key": "revenuePriorityBreakdown",
          "title": "Revenue Priority Distribution",
          "type": "pieChart",
          "span": 6,
          "height": 300,
          "dataPath": "revenuePriorityStats",
          "colorScheme": "revenue"
        },
        {
          "key": "categoryBreakdown",
          "title": "Call Categories",
          "type": "barChart",
          "span": 6,
          "height": 250,
          "xAxis": "primary_category",
          "yAxis": "count"
        },
        {
          "key": "staffPerformance",
          "title": "Staff Call Volume",
          "type": "barChart",
          "span": 6,
          "height": 250,
          "xAxis": "staff_name",
          "yAxis": "count"
        },
        {
          "key": "outcomeAnalysis",
          "title": "Call Outcomes",
          "type": "donutChart",
          "span": 4,
          "height": 200,
          "dataPath": "outcomeStats",
          "innerLabel": "Total"
        },
        {
          "key": "creditCardCapture",
          "title": "Credit Card Capture Rate",
          "type": "gaugeChart",
          "span": 4,
          "height": 200,
          "metric": "credit_card_captured",
          "target": 0.8
        },
        {
          "key": "followUpRate",
          "title": "Follow-up Required",
          "type": "gaugeChart",
          "span": 4,
          "height": 200,
          "metric": "follow_up_needed",
          "target": 0.3,
          "inverse": true
        }
      ],
      "filters": [
        {
          "key": "franchise",
          "label": "Franchise",
          "type": "select",
          "options": ["orange-theory"],
          "default": "orange-theory",
          "hidden": true
        },
        {
          "key": "siteId",
          "label": "Location",
          "type": "select",
          "options": ["5736520"],
          "default": "5736520",
          "hidden": false
        },
        {
          "key": "dateRange",
          "label": "Time Period",
          "type": "daterange",
          "default": "Last 7 Days"
        },
        {
          "key": "customer_type",
          "label": "Customer Type",
          "type": "multiselect",
          "options": [
            "prospective_client",
            "existing_member",
            "former_member",
            "returning_visitor",
            "other"
          ],
          "placeholder": "All Types"
        },
        {
          "key": "revenue_priority",
          "label": "Revenue Priority",
          "type": "multiselect",
          "options": ["high", "medium", "low", "none"],
          "placeholder": "All Priorities"
        }
      ]
    }
  },
  "permissions": {
    "roles": {
      "admin": {
        "canViewAll": true,
        "canExport": true,
        "canEditConfig": true,
        "canViewRecordings": true,
        "canViewSensitive": true,
        "canViewRawAnalysis": true
      },
      "manager": {
        "canViewAll": true,
        "canExport": true,
        "canEditConfig": false,
        "canViewRecordings": true,
        "canViewSensitive": true,
        "canViewRawAnalysis": false
      },
      "agent": {
        "canViewAll": false,
        "canExport": false,
        "canEditConfig": false,
        "canViewRecordings": "own",
        "canViewSensitive": false,
        "canViewRawAnalysis": false
      },
      "viewer": {
        "canViewAll": false,
        "canExport": false,
        "canEditConfig": false,
        "canViewRecordings": false,
        "canViewSensitive": false,
        "canViewRawAnalysis": false
      }
    }
  },
  "customComponents": {
    "CoachingCard": {
      "type": "card",
      "variant": "elevated",
      "showIcon": true,
      "iconType": "coaching"
    },
    "FeedbackPanel": {
      "type": "panel",
      "variant": "outlined",
      "showBorder": true,
      "padding": "large"
    },
    "TextPanel": {
      "type": "panel",
      "variant": "highlighted",
      "padding": "large"
    }
  },
  "enhancements": {
    "v5_features": [
      "simplified_field_structure",
      "revenue_impacting_category",
      "streamlined_coaching_feedback",
      "enhanced_follow_up_tracking",
      "call_state_detection",
      "minimal_field_mapping"
    ],
    "removed_from_v2": [
      "sales_process_evaluation",
      "retention_process_tracking",
      "cancellation_details",
      "customer_insights",
      "business_impact_assessment",
      "alert_system",
      "success_metrics"
    ]
  }
}
